import React, { FC } from 'react';

type StopIconProps = {
  width: number;
  height: number;
};
export const Stop: FC<StopIconProps> = ({ width, height }) => {
  return (
    <svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect className='hover:fill-redOrange' x='0.5' y='0.5' width='19' height='19' rx='9.5' fill='#E4E8F0' stroke='#E4E8F0'/>
      <rect x='4.11523' y='9.25' width='11.7678' height='1.5' rx='0.75' fill='white'/>
    </svg>
  );
};
